import './styles/sampleclass.css'
import "react-day-picker/style.css"
import { useState } from 'react'

//Extras
import { fontType, main } from '../assets/extras'
import Imagen from '../assets/images/clasemuestra-bg.jpeg'
import { compareDates, getCurrentDate, getCurrentDay, validateEmail, validatePhone, getAge } from '../assets/validator'
import { niveles } from '../assets/datas'
import { db } from '../assets/connections'
import { collection, doc, getDoc, getDocs, increment, query, setDoc, updateDoc, where } from 'firebase/firestore'
import { filterAndSortClasses, formatSubtitle } from '../assets/classUtils'
import { getUserLocation, sortSedesByDistance, formatDistance } from '../assets/geoUtils'

//Components
import Snack from '../components/snack'
import Loader from '../components/loader'
import { DayPicker } from "react-day-picker"
import Confirm from '../components/confirm'
import Logo from '../assets/images/logo-white.png'

const SampleClass = () => {

    const age = Array.from({ length: 98 }, (_, i) => i + 3)

    const [ data, setData ] = useState({
        nombre_jugador: "",
        correo_jugador: "",
        telefono_jugador: "",
        edad_jugador: null,
        nivel_jugador: 0,
        fecha_clase: "----/--/--"
    })
    const [ valueCalendar, setValueCalendar ] = useState(new Date())
    const [ showCalendar, setShowCalendar ] = useState(false)
    const [ selClase, setSelClase ] = useState(null)

    //Varibles para el uso del confirm
    const [ confirm, setConfirm ] = useState({
        show: false,
        title: "",
        text: ""
    })

    const [ variables, setVariables ] = useState({
        loading: false,
        sedesData: [],
        searched: false
    })

    const [ userLocation, setUserLocation ] = useState(null)
    const [ locationStatus, setLocationStatus ] = useState("idle")
    const [ showAllSedes, setShowAllSedes ] = useState(false)
    const [ resultScreen, setResultScreen ] = useState(null) // null | { type: "success"|"error", message: string }

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        // Validar que el elemento existe antes de usarlo
        if (!contSnack) {
            console.warn("contSnack no encontrado, el mensaje no se puede mostrar")
            return
        }

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
                            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #56d600;'></div>"
                          : status == "warning" ?
                            "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                          : status == "error" ?
                            "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                            "<p style='font-family:" + fontType.text +";'>" + message + "</p>" +
                            "<div className='snackBar' style='background-color: #c20000;'></div>"
                          : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            if (snack && snack.parentNode) {
                snack.remove()
            }
        }, 5000)
    }

    //Funcion que guarda al jugador en la lista de jugadores que no han terminado el registro de su clase muestra
    const savePlayer = async () => {
        let playerInfo = await isPlayerAlredyRegistered()

        if(playerInfo.exists === false){
            await setDoc(doc(db, "ClaseMuestra", data.correo_jugador), {
                nombre: data.nombre_jugador,
                correo: data.correo_jugador,
                edad: data.edad_jugador,
                nivel: data.nivel_jugador == 0 ? niveles[0] :
                          data.nivel_jugador == 1 ? niveles[1] :
                          data.nivel_jugador == 2 ? niveles[2] :
                          data.nivel_jugador == 3 ? niveles[3] : "Sin nivel",
                fecha_clase: data.fecha_clase,
                telefono: data.telefono_jugador,
                isReserved: false,
                estatus: "----/--/--",
                tipo_estatus: "",
                mensajes: 0
            }).catch(e => {
                console.log(e)
            })

            await getData()
        } else {
            if(playerInfo.reserved === false){
                await setDoc(doc(db, "ClaseMuestra", data.correo_jugador), {
                    nombre: data.nombre_jugador,
                    correo: data.correo_jugador,
                    edad: data.edad_jugador,
                    nivel: data.nivel_jugador == 0 ? niveles[0] :
                              data.nivel_jugador == 1 ? niveles[1] :
                              data.nivel_jugador == 2 ? niveles[2] :
                              data.nivel_jugador == 3 ? niveles[3] : "Sin nivel",
                    fecha_clase: data.fecha_clase,
                    telefono: data.telefono_jugador,
                    isReserved: false,
                    estatus: "----/--/--",
                    tipo_estatus: "",
                    mensajes: 0
                }).catch(e => {
                    console.log(e)
                })

                await getData()
            } else {
                setVariables(prev => ({
                    ...prev,
                    loading: false
                }))
                setTimeout(() => {
                    showMessage("Este correo ya ha sido usado para una clase muestra", "warning")
                }, 100)
            }
        }
    }

    //Funcion que valida si el jugador ingresado ya existe
    const isPlayerAlredyRegistered = async () => {
        return new Promise(async resolve => {
            await getDoc(doc(db, "ClaseMuestra", data.correo_jugador)).then(r => {
                if(r.exists()){
                    if(r.data().isReserved === true){
                        resolve ({
                            exists: true,
                            reserved: true
                        })
                    } else {
                        resolve({
                            exists: true,
                            reserved: false
                        })
                    }
                } else {
                    resolve({
                        exists: false,
                        reserved: false
                    })
                }
            }).catch(e => {
                // Si hay error (incluyendo permisos), asumimos que no existe para permitir continuar
                if (process.env.NODE_ENV === 'development') {
                    console.log("Error al verificar jugador:", e.message)
                }
                resolve({
                    exists: false,
                    reserved: false
                })
            })
        })
    }

    //Funcion que registra la clase muestra
    const onHandleReserveClass = async () => {
        setConfirm(prev => ({
            ...prev,
            show: false
        }))
        setVariables(prev => ({
            ...prev,
            loading: true
        }))

        //Actualizamos la informacion del jugador, para especificar que ya reservo la clase, en que fecha, y que clase
        await updateDoc(doc(db, "ClaseMuestra", data.correo_jugador), {
            isReserved: true,
            fecha_clase: data.fecha_clase === "NaN-NaN-NaN" ? getCurrentDate() : data.fecha_clase,
            id_clase: selClase.id,
            nombre_profesor: selClase.nombre_profesor,
            id_profesor: selClase.profesor_clase,
            academia: selClase.academia,
            ref: selClase.ref,
            asistio: false,
            nombre_clase: selClase.nombre_clase,
            dias_clase: selClase.dias_clase,
            checked: false,
            estatus: "----/--/--",
            tipo_estatus: "",
            mensajes: 0,
            sede: selClase.sedeId || "",
            nombre_sede: selClase.nombre_sede || ""
        }).then(async r => {
            await updateDoc(doc(db, selClase.ref), {
                clases_muestra: increment(1)
            }).then(async r2 => {
                // Enviar correo en background (no bloquea el flujo)
                fetch("https://us-central1-tenistapp2000.cloudfunctions.net/correo", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        correo: data.correo_jugador,
                        nombre: data.nombre_jugador,
                        nombre_clase: selClase.nombre_clase,
                        nombre_profesor: selClase.nombre_profesor,
                        fecha_clase: data.fecha_clase,
                        dias_clase: selClase.dias_clase,
                        academia: selClase.academia,
                    }),
                }).catch(e => console.log("Error enviando correo:", e))

                setVariables(prev => ({ ...prev, loading: false }))
                setResultScreen({
                    type: "success",
                    clase: selClase.nombre_clase,
                    profesor: selClase.nombre_profesor,
                    fecha: data.fecha_clase,
                    sede: selClase.nombre_sede || ""
                })
            }).catch(e => {
                console.log(e)
                setVariables(prev => ({ ...prev, loading: false }))
                setResultScreen({ type: "error", message: "No se pudo completar la reserva. Intentalo de nuevo mas tarde." })
            })
        }).catch(e => {
            console.log(e)
            setVariables(prev => ({ ...prev, loading: false }))
            setResultScreen({ type: "error", message: "No se pudo completar la reserva. Intentalo de nuevo mas tarde." })
        })

    }

    //Funcion que obtiene las clases muestra que esten disponibles - DINAMICA
    const getData = async () => {
        const level = data.nivel_jugador == 0 ? niveles[0] :
                      data.nivel_jugador == 1 ? niveles[1] :
                      data.nivel_jugador == 2 ? niveles[2] :
                      data.nivel_jugador == 3 ? niveles[3] : null

        const edad = getAge(data.edad_jugador)

        //Ahora analizamos a que categorias pertenece el jugador y las agregamos a un arreglo
        var cathegories = []
        if(edad >= 12){
            if(edad < 18) {
                cathegories = [
                    "Juvenil 12 a 18 años",
                    "Adultos"
                ]
            } else if (edad >= 18) {
                cathegories = [
                    "Adultos"
                ]
            }
        } else if(edad < 12){
            cathegories = [
                "Infantil 4 a 8 años",
                "Infantil 8 a 12 años"
            ]
        }

        var sedesData = []

        try {
            // 1. Obtener TODAS las academias dinamicamente
            const academias = await getDocs(collection(db, "Academias"))

            for (const academia of academias.docs) {
                const academiaEmail = academia.id

                // 2. Obtener sedes y filtrar client-side (resiliente a campos faltantes)
                let sedes = []
                let hasSedesCollection = false
                try {
                    const sedesSnap = await getDocs(collection(academia.ref, "Sedes"))
                    hasSedesCollection = sedesSnap.docs.length > 0
                    sedes = sedesSnap.docs.filter(s => {
                        const data = s.data()
                        return data.activa !== false && data.activa_clases_muestra !== false
                    })
                } catch(e) {
                    // No hay subcolleccion Sedes
                    console.log("No hay sedes para " + academiaEmail + ", usando academia como sede")
                }

                if (sedes.length > 0) {
                    // Tiene sedes configuradas - cargar todas las clases y distribuir por sede
                    const allClases = await getDocs(query(
                        collection(academia.ref, "Clases"),
                        where("categoria", "in", cathegories),
                        where("nivel", "==", level),
                        where("isGroup", "==", true)
                    ))

                    const defaultSedeId = (sedes.find(s => s.data().es_default) || sedes[0]).id

                    for (const sede of sedes) {
                        const sedeData = sede.data()
                        const sedeId = sede.id

                        // Filtrar client-side: clases asignadas a esta sede,
                        // o clases sin sede asignada van a la sede default
                        const sedeClases = allClases.docs.filter(d => {
                            const claseSede = d.data().sede
                            if (claseSede) return claseSede === sedeId
                            return sedeId === defaultSedeId
                        })

                        const sortedClases = filterAndSortClasses(sedeClases, academiaEmail, {
                            sedeId: sedeId,
                            nombre_sede: sedeData.nombre_sede
                        })

                        sedesData.push({
                            sedeId: sedeId,
                            nombre_sede: sedeData.nombre_sede,
                            direccion_sede: sedeData.direccion_sede,
                            coordenadas: sedeData.coordenadas || null,
                            academia: academiaEmail,
                            clases: sortedClases
                        })
                    }
                } else if (!hasSedesCollection) {
                    // Backward compatibility: academia sin sedes configuradas
                    // Cargar todas las clases (sin filtro de sede)
                    try {
                        const clases = await getDocs(query(
                            collection(academia.ref, "Clases"),
                            where("categoria", "in", cathegories),
                            where("nivel", "==", level),
                            where("isGroup", "==", true)
                        ))

                        const sortedClases = filterAndSortClasses(clases.docs, academiaEmail)

                        if (sortedClases.length > 0) {
                            sedesData.push({
                                sedeId: "",
                                nombre_sede: academia.data().nombre_academia || academiaEmail,
                                direccion_sede: academia.data().direccion_academia || "",
                                coordenadas: null,
                                academia: academiaEmail,
                                clases: sortedClases
                            })
                        }
                    } catch(e) {
                        console.log("Error cargando clases de " + academiaEmail, e.message)
                    }
                }
            }
        } catch(e) {
            console.log(e.message)
            setTimeout(() => {
                showMessage("Error de conexion. Intentalo de nuevo mas tarde.", "error")
            }, 100)
        }

        setVariables(prev => ({
            ...prev,
            loading: false,
            sedesData: sedesData,
            searched: true
        }))

        setLocationStatus("requesting")
        getUserLocation(8000)
            .then(loc => { setUserLocation(loc); setLocationStatus("granted") })
            .catch(() => setLocationStatus("denied"))

    }

    if(variables.loading)
    return (
        <Loader
            loading={variables.loading}
        />
    )

    if(resultScreen)
    return (
        <div className='mainSampleClass' style={{
            backgroundImage: "url(" + Imagen + ")",
            backgroundPosition: "center",
            backgroundSize: "cover"
        }}>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                padding: 20
            }}>
                <div style={{
                    backgroundColor: "white",
                    borderRadius: 20,
                    padding: 40,
                    maxWidth: 500,
                    width: "90%",
                    textAlign: "center",
                    boxShadow: "0 4px 20px rgba(0,0,0,0.15)"
                }}>
                    {resultScreen.type === "success" ? (
                        <>
                            <i className='fa-regular fa-circle-check' style={{ fontSize: 60, color: "#56d600", marginBottom: 20 }}></i>
                            <h2 style={{ fontFamily: fontType.title, fontSize: 24, marginBottom: 15, color: "#333" }}>
                                CLASE RESERVADA
                            </h2>
                            <p style={{ fontFamily: fontType.text, fontSize: 16, color: "#666", marginBottom: 25 }}>
                                Tu clase muestra ha sido reservada con exito. Te enviamos un correo con los detalles.
                            </p>
                            <div style={{
                                backgroundColor: "#f8f8f8",
                                borderRadius: 10,
                                padding: 20,
                                marginBottom: 25,
                                textAlign: "left"
                            }}>
                                <p style={{ fontFamily: fontType.text, fontSize: 14, margin: "6px 0", color: "#444" }}>
                                    <b>Clase:</b> {resultScreen.clase}
                                </p>
                                <p style={{ fontFamily: fontType.text, fontSize: 14, margin: "6px 0", color: "#444" }}>
                                    <b>Profesor:</b> {resultScreen.profesor}
                                </p>
                                <p style={{ fontFamily: fontType.text, fontSize: 14, margin: "6px 0", color: "#444" }}>
                                    <b>Fecha:</b> {resultScreen.fecha}
                                </p>
                                {resultScreen.sede && (
                                    <p style={{ fontFamily: fontType.text, fontSize: 14, margin: "6px 0", color: "#444" }}>
                                        <b>Sede:</b> {resultScreen.sede}
                                    </p>
                                )}
                            </div>
                            <button onClick={() => window.location.reload()} style={{
                                backgroundColor: main,
                                color: "white",
                                border: "none",
                                borderRadius: 10,
                                padding: "14px 30px",
                                fontSize: 16,
                                fontFamily: fontType.subTitle,
                                cursor: "pointer"
                            }}>
                                VOLVER AL INICIO
                            </button>
                        </>
                    ) : (
                        <>
                            <i className='fa-solid fa-circle-xmark' style={{ fontSize: 60, color: "#c20000", marginBottom: 20 }}></i>
                            <h2 style={{ fontFamily: fontType.title, fontSize: 24, marginBottom: 15, color: "#333" }}>
                                ERROR AL RESERVAR
                            </h2>
                            <p style={{ fontFamily: fontType.text, fontSize: 16, color: "#666", marginBottom: 25 }}>
                                {resultScreen.message}
                            </p>
                            <button onClick={() => { setResultScreen(null) }} style={{
                                backgroundColor: main,
                                color: "white",
                                border: "none",
                                borderRadius: 10,
                                padding: "14px 30px",
                                fontSize: 16,
                                fontFamily: fontType.subTitle,
                                cursor: "pointer"
                            }}>
                                INTENTAR DE NUEVO
                            </button>
                        </>
                    )}
                </div>
            </div>
        </div>
    )

    if(!variables.loading)
    return (
        <div className='mainSampleClass' style={{
            backgroundImage: "url(" + Imagen + ")",
            backgroundPosition: "center",
            backgroundSize: "cover"
        }}>

            <Snack />

            <Confirm
                confirm={confirm}
                setConfirm={setConfirm}
                onHandle={onHandleReserveClass}
            />

            <div className='contSampleClass'>

                {
                    showCalendar && (
                        <div style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10000
                        }} onClick={() => setShowCalendar(false)}>
                            <div style={{
                                background: "#fff",
                                padding: "20px",
                                borderRadius: "10px",
                            }} onClick={(e) => e.stopPropagation()}>
                                <DayPicker
                                    style={{
                                        fontFamily: fontType.text
                                    }}
                                    mode="single"
                                    selected={valueCalendar}
                                    disabled={(date) => {
                                        // Deshabilitar fechas pasadas
                                        const today = new Date()
                                        today.setHours(0, 0, 0, 0)
                                        if (date < today) return true
                                        // Deshabilitar días que no son de clase
                                        const dayName = date.getDay() > 0 ? getCurrentDay(date.getDay()) : "Domingo"
                                        return !selClase.dias_clase.some(v => v.dia === dayName)
                                    }}
                                    onSelect={(e) => {
                                        if(e != undefined){
                                            let date = new Date(e)
                                            let newDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()

                                            setData(prev => ({
                                                ...prev,
                                                fecha_clase: newDate
                                            }))

                                            setShowCalendar(false)
                                            setConfirm(prev => ({
                                                ...prev,
                                                show: true,
                                                title: "RESERVAR CLASE",
                                                text: "¿Estas seguro de reservar tu clase muestra?"
                                            }))
                                        }
                                    }}
                                    footer={
                                        data.fecha_clase ? `Fecha: ${data.fecha_clase}` : "Selecciona un dia."
                                    }
                                />
                            </div>
                        </div>
                    )
                }

                <div className='title'>
                    <img src={Logo} />
                </div>
                {
                    variables.searched === true ?
                        <div className='formC' style={{
                            overflowY: "scroll"
                        }}>
                            {(() => {
                                const sortedSedes = userLocation
                                    ? sortSedesByDistance(variables.sedesData, userLocation)
                                    : variables.sedesData

                                const nearestSede = sortedSedes[0]?.distance != null ? sortedSedes[0] : null
                                const otherSedes = nearestSede ? sortedSedes.slice(1) : sortedSedes
                                const hasManySeeds = variables.sedesData.length > 1

                                const renderSede = (sede, idx, isRecommended) => (
                                    <div key={sede.sedeId || idx} className={isRecommended ? 'sede-recomendada' : ''}>
                                        <p style={{
                                            fontFamily: fontType.title,
                                            color: "white",
                                            fontSize: 40,
                                            marginBottom: 5,
                                            marginTop: idx > 0 && !isRecommended ? 30 : 0,
                                            width: "100%",
                                            textAlign: "center"
                                        }}>{sede.nombre_sede.toUpperCase()}</p>
                                        {sede.distance != null && (
                                            <span className='distancia-badge' style={{
                                                fontFamily: fontType.text
                                            }}>{formatDistance(sede.distance)}</span>
                                        )}
                                        {sede.direccion_sede && (
                                            <button style={{
                                                marginBottom: 20,
                                                marginTop: 10,
                                                border: "none",
                                                padding: 12,
                                                backgroundColor: "white",
                                                borderRadius: 5,
                                                fontFamily: fontType.title,
                                                fontSize: 18,
                                                cursor: "pointer",
                                                color: "black"
                                            }} onClick={() => {
                                                if (sede.coordenadas && sede.coordenadas.lat && sede.coordenadas.lng) {
                                                    window.open(`https://www.google.com/maps?q=${sede.coordenadas.lat},${sede.coordenadas.lng}`, "_blank")
                                                } else {
                                                    window.open(`https://www.google.com/maps?q=${encodeURIComponent(sede.direccion_sede)}`, "_blank")
                                                }
                                            }}>
                                                VER UBICACION
                                            </button>
                                        )}
                                        {
                                            sede.clases.length > 0 ?
                                                sede.clases.map((v, i) => {
                                                    return (
                                                        <div className='clase' key={v.id + "-" + i} onClick={() => {
                                                            setSelClase(v)
                                                            setShowCalendar(true)
                                                        }}>
                                                            <p style={{
                                                                fontFamily: fontType.text,
                                                                fontSize: 18
                                                            }}>{formatSubtitle(v.dias_clase)}</p>
                                                            <p style={{
                                                                fontFamily: fontType.text,
                                                                fontSize: 14,
                                                                marginTop: 10
                                                            }}>{v.nombre_profesor}</p>
                                                        </div>
                                                    )
                                                })
                                            :
                                                <p style={{
                                                    color: "white",
                                                    fontSize: 20,
                                                    fontFamily: fontType.subTitle,
                                                    paddingTop: 50,
                                                    paddingBottom: 50,
                                                    width: "100%",
                                                    textAlign: "center"
                                                }}>No hay clases disponibles en este centro</p>
                                        }
                                    </div>
                                )

                                return (
                                    <>
                                        {locationStatus === "requesting" && hasManySeeds && (
                                            <div style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                marginBottom: 20
                                            }}>
                                                <p style={{
                                                    color: "white",
                                                    fontFamily: fontType.text,
                                                    fontSize: 16,
                                                    marginBottom: 15
                                                }}>Buscando la sede mas cercana a ti...</p>
                                                <button className='otras-sedes-btn' style={{
                                                    fontFamily: fontType.title
                                                }} onClick={() => setLocationStatus("denied")}>
                                                    SALTAR
                                                </button>
                                            </div>
                                        )}

                                        {locationStatus === "denied" && hasManySeeds && (
                                            <div className='location-banner' style={{
                                                fontFamily: fontType.text
                                            }}>
                                                Activa tu ubicacion para ver la sede mas cercana
                                            </div>
                                        )}

                                        {locationStatus === "granted" && nearestSede && hasManySeeds ? (
                                            <>
                                                <p style={{
                                                    fontFamily: fontType.title,
                                                    color: "#4CAF50",
                                                    fontSize: 18,
                                                    marginBottom: 10,
                                                    textAlign: "center"
                                                }}>SEDE RECOMENDADA</p>
                                                {renderSede(nearestSede, 0, true)}

                                                {otherSedes.length > 0 && !showAllSedes && (
                                                    <button className='otras-sedes-btn' style={{
                                                        fontFamily: fontType.title,
                                                        marginTop: 30
                                                    }} onClick={() => setShowAllSedes(true)}>
                                                        VER OTRAS SEDES ({otherSedes.length} mas)
                                                    </button>
                                                )}

                                                {showAllSedes && otherSedes.map((sede, idx) =>
                                                    renderSede(sede, idx + 1, false)
                                                )}
                                            </>
                                        ) : (
                                            locationStatus !== "requesting" || !hasManySeeds ?
                                                sortedSedes.map((sede, idx) =>
                                                    renderSede(sede, idx, false)
                                                )
                                            : null
                                        )}

                                        {variables.sedesData.length === 0 && (
                                            <p style={{
                                                color: "white",
                                                fontSize: 20,
                                                fontFamily: fontType.subTitle,
                                                paddingTop: 50,
                                                paddingBottom: 50,
                                                width: "100%",
                                                textAlign: "center"
                                            }}>No hay sedes con clases disponibles</p>
                                        )}
                                    </>
                                )
                            })()}

                            <button style={{
                                padding: 20,
                                borderRadius: 10,
                                fontFamily: fontType.title,
                                fontSize: 20,
                                marginTop: 50,
                                border: "none",
                                cursor: "pointer"
                            }} onClick={() => {
                                setVariables(prev => ({
                                    ...prev,
                                    sedesData: [],
                                    searched: false
                                }))
                                setUserLocation(null)
                                setLocationStatus("idle")
                                setShowAllSedes(false)
                            }}>
                                REGRESAR
                            </button>
                        </div>
                    :
                        <div className="form">

                            <div className='contNombre' id='contNombre'>
                                <p style={{
                                    fontFamily: fontType.title
                                }}>Escribe tu nombre completo</p>
                                <input
                                    style={{
                                        fontFamily: fontType.text,
                                        marginBottom: 30
                                    }}
                                    maxLength={100}
                                    value={data.nombre_jugador}
                                    onChange={e => {
                                        setData(prev => ({
                                            ...prev,
                                            nombre_jugador: e.target.value.toUpperCase()
                                        }))
                                    }}
                                />

                                <p style={{
                                    fontFamily: fontType.title
                                }}>Escribe tu correo electronico</p>
                                <input
                                    style={{
                                        fontFamily: fontType.text
                                    }}
                                    maxLength={40}
                                    value={data.correo_jugador}
                                    onChange={e => {
                                        setData(prev => ({
                                            ...prev,
                                            correo_jugador: e.target.value.toString().replace(" ", "").toLowerCase()
                                        }))
                                    }}
                                />

                                <p style={{
                                    fontFamily: fontType.title,
                                    marginTop: 20
                                }}>Escribe tu telefono</p>
                                <input
                                    style={{
                                        fontFamily: fontType.text
                                    }}
                                    maxLength={10}
                                    value={data.telefono_jugador}
                                    placeholder='----------'
                                    onChange={e => {
                                        setData(prev => ({
                                            ...prev,
                                            telefono_jugador: e.target.value.toString().replace(" ", "")
                                        }))
                                    }}
                                />

                                <button onClick={() => {

                                    //Primero validamos si los campos no estan vacios
                                    if(data.nombre_jugador.length <= 15){
                                        showMessage("Agrega tu nombre completo", "warning")
                                    } else {
                                        if(data.correo_jugador <= 10){
                                            showMessage("Agrega tu correo", "warning")
                                        } else {
                                            if(validateEmail(data.correo_jugador) === false){
                                                showMessage("Agrega un correo valido", "warning")
                                            } else {
                                                if(validatePhone(data.telefono_jugador) === false){
                                                    showMessage("Debes ingresar un numero de telefono valido. (10 Digitos)", "warning")
                                                } else {
                                                    const cont2 = document.getElementById("contNombre")
                                                    cont2.style.animation = "hide 2s ease-in-out forwards"

                                                    setTimeout(() => {
                                                        cont2.style.zIndex = -10
                                                    }, 2000)

                                                    const cont = document.getElementById("contNivel")
                                                    cont.style.zIndex = 10
                                                    cont.style.animation = "show 2s ease-in-out forwards"
                                                }
                                            }
                                        }
                                    }

                                }} style={{
                                    fontFamily: fontType.title
                                }}>
                                    SIGUIENTE
                                </button>
                            </div>

                            <div className='contNivel' id='contNivel'>
                                <p style={{
                                    fontFamily: fontType.title
                                }}>¿Cuanto tiempo has tomado clases?</p>

                                <div className='custom-select'>
                                    <select style={{
                                        fontFamily: fontType.text
                                    }} value={data.nivel_jugador} onChange={e => {
                                        setData(prev => ({
                                            ...prev,
                                            nivel_jugador: e.target.value
                                        }))
                                    }}>
                                        <option value={0 /* Bola roja */}>Nunca he tomado clases/Menos de 6 meses</option>
                                        <option value={1 /* Bola naranja */}>Mas de 6 meses a 1 año</option>
                                        <option value={2 /* Bola verde */}>Mas de 1 año a 3 años</option>
                                        <option value={3 /* Clase D / Particulares */}>3 años o mas</option>
                                    </select>
                                </div>

                                <button onClick={() => {

                                    const cont2 = document.getElementById("contNivel")
                                    cont2.style.animation = "hide 2s ease-in-out forwards"

                                    setTimeout(() => {
                                        cont2.style.zIndex = -10
                                    }, 2000)

                                    const cont = document.getElementById("contEdad")
                                    cont.style.zIndex = 10
                                    cont.style.animation = "show 2s ease-in-out forwards"

                                }} style={{
                                    fontFamily: fontType.title
                                }}>
                                    SIGUIENTE
                                </button>

                                <button onClick={() => {
                                    const cont2 = document.getElementById("contNivel")
                                    cont2.style.animation = "hide 2s ease-in-out forwards"

                                    setTimeout(() => {
                                        cont2.style.zIndex = -10
                                    }, 2000)

                                    const cont = document.getElementById("contNombre")
                                    cont.style.zIndex = 10
                                    cont.style.animation = "show 2s ease-in-out forwards"

                                }} style={{
                                    fontFamily: fontType.title
                                }}>
                                    ATRAS
                                </button>
                            </div>

                            <div className='contEdad' id='contEdad'>
                                <p style={{
                                    fontFamily: fontType.title
                                }}>Selecciona tu fecha de nacimiento</p>

                                <input style={{
                                        fontFamily: fontType.text,
                                        width: "60%",
                                        height: 40,
                                        padding: 10,
                                        borderRadius: 10,
                                        border: "2px solidrgb(117, 117, 117)"
                                    }} type="date"
                                    onChange={e => setData({ ...data, edad_jugador: e.target.value })}
                                    value={data.edad_jugador}
                                />

                                <button style={{
                                    fontFamily: fontType.title
                                }}
                                onClick={() => {

                                    if(data.edad_jugador != null){
                                        const edad = getAge(data.edad_jugador)

                                        if(edad > 3 && edad < 100){
                                            setVariables(prev => ({
                                                ...prev,
                                                loading: true
                                            }))

                                            setTimeout(async () => {
                                                await savePlayer()
                                            }, 50)
                                        } else {
                                            showMessage("Ingresa una fecha valida mayor a 3 años.", "warning")
                                        }
                                    } else {
                                        showMessage("Debes ingresar una edad", "warning")
                                    }


                                }}
                                >
                                    SIGUIENTE
                                </button>

                                <button onClick={() => {
                                    const cont2 = document.getElementById("contEdad")
                                    cont2.style.animation = "hide 2s ease-in-out forwards"

                                    setTimeout(() => {
                                        cont2.style.zIndex = -10
                                    }, 2000)

                                    const cont = document.getElementById("contNivel")
                                    cont.style.zIndex = 10
                                    cont.style.animation = "show 2s ease-in-out forwards"

                                }} style={{
                                    fontFamily: fontType.title
                                }}>
                                    ATRAS
                                </button>
                            </div>
                        </div>
                }
            </div>

        </div>
    )
}

export default SampleClass
